import styled from 'styled-components';

export const SurveysCard = styled.div`
  box-shadow: 0 4rem 5rem -2rem rgba(0, 0, 0, 0.42);
  margin-top: 5px;
  background: ${({ theme }) => theme.white.a10};
  border-radius: 5px;
  padding: 15px;
`;

export const GridHeadline = styled.h3`
  background: ${({ theme }) => theme.background};
  text-align: center;
  text-transform: uppercase;
  border-radius: 5px;
  padding: 15px;
  margin: 15px 0;
`;
